import React from "react";
import styled from "styled-components";
import TasteProgressBar from "./TasteProgressBar";

interface FlavorSelectorProps {
    tasteValues: {
        sweetness: number;
        sourness: number;
        freshness: number;
        thickness: number;
    };
    onChange?: (taste: "sweetness" | "sourness" | "freshness" | "thickness") => (value: number) => void;
    readOnly?: boolean;
}

const FlavorSelector: React.FC<FlavorSelectorProps> = ({ tasteValues, onChange, readOnly = false }) => {
    return (
        <TasteProgressList>
            <TasteProgressBar
                label="단맛"
                value={tasteValues.sweetness}
                onChange={!readOnly && onChange ? onChange("sweetness") : undefined}
            />
            <TasteProgressBar
                label="신맛"
                value={tasteValues.sourness}
                onChange={!readOnly && onChange ? onChange("sourness") : undefined}
            />
            <TasteProgressBar
                label="향의 세기"
                value={tasteValues.freshness}
                onChange={!readOnly && onChange ? onChange("freshness") : undefined}
            />
            <TasteProgressBar
                label="탄산감"
                value={tasteValues.thickness}
                onChange={!readOnly && onChange ? onChange("thickness") : undefined}
            />
        </TasteProgressList>
    );
};

const TasteProgressList = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0;
    gap: 20px;
    width: 100%;
    max-width: 321px;
`;

export default FlavorSelector;
